var _g, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMicromobility = function SvgMicromobility(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.5,
    d: "M5 15a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zM18 15a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M18.248 11.968A3.5 3.5 0 0 0 13 15.002"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.24 3.126a.75.75 0 1 0-1.48-.252L5.5 3zM3.621 14.023l.739.126L6.239 3.126 5.5 3l-.74-.126-1.878 11.023z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m8 15.072-.433.25a.5.5 0 0 0 .433.25zM4.933 8.75a.5.5 0 1 0-.866.5L4.5 9zM15 15.072v-.5H8v1h7zm-7 0 .433-.25-3.5-6.072L4.5 9l-.433.25 3.5 6.072z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M5.5 3h3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m13 7 1.146-4.582c.03-.122-.117-.207-.208-.12L9.453 6.568A.25.25 0 0 0 9.625 7H11l-1.146 4.582c-.03.121.117.207.208.12l4.712-4.486A.125.125 0 0 0 14.688 7z"
  })));
};
export default SvgMicromobility;